module.exports = __webpack_public_path__ + "static/media/twitter.0826ae5c.svg";